import { useEffect } from 'react';
import { useLocation, useMatch } from 'react-router-dom';

import { Container, DataService, AuthService } from '../../../../symphony';

import { SlNavBarPositions, SlNavbarThemes } from '../../../../shared/public/globalInterfaces/globalInterfaces';

export function NavigationBar() {
	const hideNavUrls = [
		useMatch(':language/learn/courses/:courseAlias/lesson/:id/*'),
		useMatch(':language/learn/courses/:courseAlias/skip-ahead/:id/*'),
		useMatch(':language/learn/courses/:courseAlias/tiy/:id/*'),
		useMatch(':language/learn/courses/:courseAlias/code-coach/:id/*'),
		useMatch(':language/learn/courses/:courseAlias/code-project/:id/*'),
		useMatch(':language/learn/courses/:courseAlias/code-repo/:id/*'),
		useMatch(':language/learn/learning-paths/:alias/lesson/:id/*'),
		useMatch(':language/learn/learning-paths/:alias/tiy/:id/*'),
		useMatch(':language/learn/learning-paths/:alias/code-coach/:id/*'),
		useMatch(':language/learn/learning-paths/:alias/code-project/:id/*'),
		useMatch(':language/learn/learning-paths/:alias/code-repo/:id/*'),
	];

	const isInCourseRoute = !!useMatch(':lng/learn/courses/:courseAlias');

	const isInPathRoute = !!useMatch(':lng/learn/learning-paths/:alias');

	const pathName = useLocation().pathname;

	const { showNavItems$ } = Container.take('global', DataService);

	const authService = Container.take('global', AuthService);

	useEffect(() => {
		// TODO: Ping Levon for refactor
		const SlNavigationServiceInstance: any = Container.take(
			'global',
			'slNavigationService',
		);

		const service = new SlNavigationServiceInstance();

		const hideNavRoute = hideNavUrls.find((el) => !!el);

		if (hideNavRoute) {
			service?.hide();
		} else {
			service?.show();
			service?.setTheme(SlNavbarThemes.light);
			service?.setInitialConfigs({
				navbarPosition: SlNavBarPositions.relative,
			});
		}

		if (isInCourseRoute || isInPathRoute) {
			service?.setInitialConfigs({
				navbarPosition: authService.isLoggedIn()
					? SlNavBarPositions.sticky
					: SlNavBarPositions.relative,
			});
			showNavItems$.next(true);
			document.body.style.overflow = 'visible';
		} else {
			showNavItems$.next(false);
		}
	}, [pathName]);

	useEffect(() => () => {
		showNavItems$.next(false);
	}, []);

	return null;
}
